import { render, staticRenderFns } from "./Notificationrules.vue?vue&type=template&id=15dd7c2c"
import script from "./Notificationrules.vue?vue&type=script&lang=js"
export * from "./Notificationrules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports